import * as yup from 'yup'
import { paymentReleaseDateProblemMessages } from 'src/constants/invoice/constants'
import { PaymentReleaseDateProblem } from 'src/constants/invoice/enums'
import { validateReleaseWallClock } from 'src/utils/paymentReleaseTime'
import { isValidPickerValue, wallClockFromPicker } from './pickerWallClock'

/**
 * Mirrors the server so the admin does not round-trip for an obvious mistake: a future time, at
 * most 30 days out, both judged in Central Time. Evaluated against the clock at submit time, so
 * a modal left open past the boundary cannot submit a stale pick — the picker's `minDate` and
 * `maxDate` only grey out whole days. The 422 is still handled: client and server clocks can
 * disagree near either edge.
 *
 * `nullable()` first, as in `RescheduleJobPanel.validator.ts`: a cleared picker writes `null`,
 * which `yup.mixed()` would otherwise reject before any test runs.
 */
export const paymentReleaseScheduleValidator = yup.object({
  releaseAt: yup
    .mixed()
    .nullable()
    .required('Required')
    .test('in-release-window', '', function testReleaseWindow(value) {
      if (!isValidPickerValue(value)) {
        return this.createError({
          message: paymentReleaseDateProblemMessages[PaymentReleaseDateProblem.Invalid],
        })
      }

      const problem = validateReleaseWallClock(wallClockFromPicker(value))

      if (problem) {
        return this.createError({ message: paymentReleaseDateProblemMessages[problem] })
      }

      return true
    }),
})
